import component from "./Offers";
export default component;
